import React from "react";
import PartOutlierPanel from "./PartOutlierPanel";
import SectionLoader from "../general/component/loading";

export default function SectionOutlier({
                                           jwtToken,
                                           outlierForm,
                                           outlierFormName,
                                           outlierVarOptions,
                                           onFormChange,
                                           onFormSubmit,
                                           outliers,
                                           twoAfcs,
                                           handleUpdate,
                                           showAlert,
                                           loading
                                       }) {
    return (
        <section style={{marginBottom: "40px"}}>
            <h2 style={{marginTop: "40px"}}>Outlier Detection</h2>
            <hr style={{marginTop: "0px"}}/>
            {/* form for creating new outlier table */}
            <div className="form-group" style={{width: "800px", marginBottom: "20px"}}>
                <form id="createOutlier" onSubmit={onFormSubmit}>
                    <table className="table">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Variable</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td style={{width: "200px"}}>
                                <input style={{width: "200px"}}
                                       className="form-control"
                                       type="text"
                                       name="name"
                                       placeholder="outlier name..."
                                       value={outlierFormName}
                                       onChange={onFormChange}/>
                            </td>
                            <td style={{width: "220px"}}>
                                <select style={{width: "220px"}}
                                        value={outlierForm.variable}
                                        onChange={onFormChange}
                                        className="form-control"
                                        name="variable">
                                    <option value="">---Select variable---</option>
                                    {outlierVarOptions}
                                </select>
                            </td>
                            <td>
                                <button type="submit"
                                        style={{marginTop: "2px", paddingLeft: "30px", paddingRight: "30px"}}
                                        className="btn btn-primary"
                                        title="Create outlier table" onClick={onFormSubmit}>CREATE</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </form>
            </div>
            {/* render all outlier tables */}
            {loading ? (
                <SectionLoader />
            ) : outliers && outliers.length > 0 ? (
                outliers.map((outlier, index) => (
                    <PartOutlierPanel
                        key={outlier.id}
                        jwtToken={jwtToken}
                        outlierIndex={index}
                        outlierData={outlier}
                        twoAfcs={twoAfcs}
                        handleUpdate={handleUpdate}
                        showAlert={showAlert}
                    />
                ))
            ) : (
                <div className="alert alert-warning" style={{ textAlign: "center" }}>
                    <strong>No Outlier Detections created.</strong>
                </div>
            )}
        </section>
    );
}
